var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { staticClass: "fa-page", attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c(
                "w-card",
                [
                  _c(
                    "w-card-title",
                    [
                      _c("div", { staticClass: "fa-head" }, [
                        _c(
                          "span",
                          { staticClass: "fa-head-icon" },
                          [_c("w-fa", { attrs: { icon: "calculator" } })],
                          1
                        ),
                        _c("div", { staticClass: "fa-head-text" }, [
                          _c("span", { staticClass: "fa-title" }, [
                            _vm._v(_vm._s(_vm.$ct("title"))),
                          ]),
                          _c("span", { staticClass: "fa-subtitle" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$ct("subtitle", { bookYear: _vm.bookYear })
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          staticClass: "mr",
                          attrs: { icon: "plus" },
                          on: {
                            click: function ($event) {
                              return _vm.$router.push("/fixed-assets/new")
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("new")) + " ")]
                      ),
                      _c(
                        "w-button",
                        {
                          attrs: {
                            icon: "book",
                            disabled: _vm.isBooking || _vm.assets.length == 0,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.bookDepreciations()
                            },
                          },
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$ct("book-depreciations", {
                                  bookYear: _vm.bookYear,
                                })
                              ) +
                              " "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm.loaded
                    ? _c(
                        "w-card-content",
                        [
                          _c("div", { staticClass: "fa-stats" }, [
                            _c("div", { staticClass: "fa-stat" }, [
                              _c("div", { staticClass: "fa-stat-num" }, [
                                _vm._v(_vm._s(_vm.activeAssets.length)),
                              ]),
                              _c("div", { staticClass: "fa-stat-label" }, [
                                _vm._v(_vm._s(_vm.$ct("stats.active"))),
                              ]),
                            ]),
                            _c("div", { staticClass: "fa-stat" }, [
                              _c("div", { staticClass: "fa-stat-num" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.printHumanFloat(
                                      _vm.activeAcquisitionTotal
                                    )
                                  )
                                ),
                              ]),
                              _c("div", { staticClass: "fa-stat-label" }, [
                                _vm._v(
                                  _vm._s(_vm.$ct("stats.acquisition-total"))
                                ),
                              ]),
                            ]),
                            _c("div", { staticClass: "fa-stat" }, [
                              _c("div", { staticClass: "fa-stat-num" }, [
                                _vm._v(_vm._s(_vm.disposedAssets.length)),
                              ]),
                              _c("div", { staticClass: "fa-stat-label" }, [
                                _vm._v(_vm._s(_vm.$ct("stats.disposed"))),
                              ]),
                            ]),
                            _c(
                              "div",
                              {
                                staticClass: "fa-stat",
                                class: {
                                  "fa-stat-attention":
                                    _vm.missingPurchases.length > 0,
                                },
                              },
                              [
                                _c("div", { staticClass: "fa-stat-num" }, [
                                  _vm._v(_vm._s(_vm.missingPurchases.length)),
                                ]),
                                _c("div", { staticClass: "fa-stat-label" }, [
                                  _vm._v(_vm._s(_vm.$ct("stats.missing"))),
                                ]),
                              ]
                            ),
                          ]),
                          _vm.assets.length == 0
                            ? _c(
                                "div",
                                { staticClass: "fa-empty" },
                                [
                                  _c(
                                    "span",
                                    { staticClass: "fa-empty-icon" },
                                    [
                                      _c("w-fa", {
                                        attrs: { icon: "calculator" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("div", { staticClass: "fa-empty-title" }, [
                                    _vm._v(_vm._s(_vm.$ct("empty"))),
                                  ]),
                                  _c("div", { staticClass: "fa-empty-hint" }, [
                                    _vm._v(_vm._s(_vm.$ct("empty-hint"))),
                                  ]),
                                  _c(
                                    "w-button",
                                    {
                                      attrs: { icon: "plus" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.$router.push(
                                            "/fixed-assets/new"
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(" " + _vm._s(_vm.$ct("new")) + " ")]
                                  ),
                                ],
                                1
                              )
                            : _c(
                                "app-custom-table",
                                { staticClass: "fa-table" },
                                [
                                  _c("thead", [
                                    _c("tr", [
                                      _c("th", [
                                        _vm._v(_vm._s(_vm.$ct("name"))),
                                      ]),
                                      _c("th", { attrs: { width: "200" } }, [
                                        _vm._v(_vm._s(_vm.$ct("supplier"))),
                                      ]),
                                      _c("th", { attrs: { width: "130" } }, [
                                        _vm._v(_vm._s(_vm.$ct("purchase"))),
                                      ]),
                                      _c("th", { attrs: { width: "110" } }, [
                                        _vm._v(_vm._s(_vm.$ct("start-date"))),
                                      ]),
                                      _c("th", { attrs: { width: "190" } }, [
                                        _vm._v(_vm._s(_vm.$ct("method"))),
                                      ]),
                                      _c(
                                        "th",
                                        {
                                          staticClass: "right",
                                          attrs: { width: "130" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.$ct("acquisition-value"))
                                          ),
                                        ]
                                      ),
                                      _c("th", { attrs: { width: "230" } }, [
                                        _vm._v(_vm._s(_vm.$ct("ledgers"))),
                                      ]),
                                      _c("th", { attrs: { width: "130" } }, [
                                        _vm._v(_vm._s(_vm.$ct("status"))),
                                      ]),
                                    ]),
                                  ]),
                                  _c(
                                    "tbody",
                                    _vm._l(_vm.assets, function (asset) {
                                      return _c(
                                        "tr",
                                        {
                                          key: asset.ID,
                                          staticClass: "fa-row",
                                          class: {
                                            "fa-row-disposed": asset.DisposedAt,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openAsset(asset)
                                            },
                                          },
                                        },
                                        [
                                          _c("td", [
                                            _c(
                                              "div",
                                              { staticClass: "fa-name" },
                                              [_vm._v(_vm._s(asset.Name))]
                                            ),
                                            asset.Description
                                              ? _c(
                                                  "small",
                                                  {
                                                    staticClass:
                                                      "fa-description",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(asset.Description)
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                asset.Contact
                                                  ? asset.Contact.getDisplayName()
                                                  : "—"
                                              )
                                            ),
                                          ]),
                                          _c("td", [
                                            asset.Purchase
                                              ? _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      asset.Purchase
                                                        .ComputedFriendlyID
                                                    )
                                                  ),
                                                ])
                                              : _c(
                                                  "small",
                                                  { staticClass: "fa-muted" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ct(
                                                          "no-purchase-short"
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                          ]),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.printLocalDate(
                                                  asset.StartDate
                                                )
                                              )
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "span",
                                              { staticClass: "fa-method" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$ct(
                                                      `methods.${asset.Method}`
                                                    )
                                                  )
                                                ),
                                              ]
                                            ),
                                            asset.Years > 0
                                              ? _c(
                                                  "small",
                                                  { staticClass: "fa-muted" },
                                                  [
                                                    _vm._v(
                                                      "· " +
                                                        _vm._s(
                                                          _vm.$ct(
                                                            "years-short",
                                                            {
                                                              years:
                                                                asset.Years,
                                                            }
                                                          )
                                                        )
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]),
                                          _c(
                                            "td",
                                            { staticClass: "right fa-amount" },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.printHumanFloat(
                                                    asset.AcquisitionValue
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                          _c("td", [
                                            _c(
                                              "span",
                                              { staticClass: "fa-ledgers" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value:
                                                          _vm.$ct(
                                                            "asset-ledger"
                                                          ),
                                                        expression:
                                                          "$ct('asset-ledger')",
                                                      },
                                                    ],
                                                    staticClass: "fa-ledger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        asset.AssetLedgerCode ||
                                                          "—"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value: _vm.$ct(
                                                          "depreciation-ledger"
                                                        ),
                                                        expression:
                                                          "$ct('depreciation-ledger')",
                                                      },
                                                    ],
                                                    staticClass: "fa-ledger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        asset.DepreciationLedgerCode ||
                                                          "—"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    directives: [
                                                      {
                                                        name: "tooltip",
                                                        rawName: "v-tooltip",
                                                        value:
                                                          _vm.$ct(
                                                            "cost-ledger"
                                                          ),
                                                        expression:
                                                          "$ct('cost-ledger')",
                                                      },
                                                    ],
                                                    staticClass: "fa-ledger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        asset.CostLedgerCode ||
                                                          "—"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c("td", [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "fa-chip",
                                                class: _vm.statusClass(asset),
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.statusLabel(asset))
                                                ),
                                              ]
                                            ),
                                          ]),
                                        ]
                                      )
                                    }),
                                    0
                                  ),
                                ]
                              ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.loaded && _vm.missingPurchases.length > 0
                ? _c(
                    "w-card",
                    { staticClass: "mt" },
                    [
                      _c("w-card-title", [
                        _c(
                          "span",
                          { staticClass: "fa-missing-icon" },
                          [_c("w-fa", { attrs: { icon: "exclamation" } })],
                          1
                        ),
                        _vm._v(" " + _vm._s(_vm.$ct("missing-title")) + " "),
                        _c("span", { staticClass: "fa-count" }, [
                          _vm._v(_vm._s(_vm.missingPurchases.length)),
                        ]),
                      ]),
                      _c(
                        "w-card-content",
                        [
                          _c("p", { staticClass: "fa-missing-info" }, [
                            _vm._v(_vm._s(_vm.$ct("missing-info"))),
                          ]),
                          _c("app-custom-table", { staticClass: "fa-table" }, [
                            _c("thead", [
                              _c("tr", [
                                _c("th", { attrs: { width: "130" } }, [
                                  _vm._v(_vm._s(_vm.$ct("purchase"))),
                                ]),
                                _c("th", [_vm._v(_vm._s(_vm.$ct("supplier")))]),
                                _c("th", { attrs: { width: "130" } }, [
                                  _vm._v(_vm._s(_vm.$ct("invoice-date"))),
                                ]),
                                _c(
                                  "th",
                                  {
                                    staticClass: "right",
                                    attrs: { width: "150" },
                                  },
                                  [_vm._v(_vm._s(_vm.$ct("business-assets")))]
                                ),
                                _c("th", { attrs: { width: "220" } }),
                              ]),
                            ]),
                            _c(
                              "tbody",
                              _vm._l(_vm.missingPurchases, function (item) {
                                return _c(
                                  "tr",
                                  {
                                    key: `${item.purchase.BookYear}-${item.purchase.ID}`,
                                    staticClass: "fa-row",
                                    on: {
                                      click: function ($event) {
                                        return _vm.createFromPurchase(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("td", { staticClass: "fa-name" }, [
                                      _vm._v(
                                        _vm._s(item.purchase.ComputedFriendlyID)
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          item.purchase.Contact
                                            ? item.purchase.Contact.getDisplayName()
                                            : "—"
                                        )
                                      ),
                                    ]),
                                    _c("td", [
                                      _vm._v(
                                        _vm._s(
                                          _vm.printLocalDate(
                                            item.purchase.InvoiceDate
                                          )
                                        )
                                      ),
                                    ]),
                                    _c(
                                      "td",
                                      { staticClass: "right fa-amount" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.printHumanFloat(
                                              item.purchase.VATBuisinessAssets
                                            )
                                          )
                                        ),
                                      ]
                                    ),
                                    _c("td", { staticClass: "right" }, [
                                      _c(
                                        "span",
                                        { staticClass: "fa-action" },
                                        [
                                          _c("w-fa", {
                                            staticClass: "mr",
                                            attrs: { icon: "plus" },
                                          }),
                                          _vm._v(
                                            _vm._s(
                                              _vm.$ct("create-depreciation")
                                            )
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          staticClass: "w100",
          attrs: {
            value: _vm.$route.path != "/fixed-assets",
            "full-height": "",
            "escape-close": "",
          },
        },
        [
          _c("router-view", {
            key: _vm.$route.path,
            on: {
              refresh: function ($event) {
                return _vm.refresh()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }